import script from "./CopyLinksList.vue?vue&type=script&setup=true&lang=js"
export * from "./CopyLinksList.vue?vue&type=script&setup=true&lang=js"

import "./CopyLinksList.vue?vue&type=style&index=0&id=5cf31700&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cf31700"]])

export default __exports__